import { ApiClient } from '@/services/Http'
import { toQueryString } from '@/helpers/utils'
import { Dealer, EditDealer } from '@/types'

const get = async (getParams?: Record<string, unknown>) => {
  const params = getParams ? toQueryString(getParams) : null
  const query = params ? `dealers?${params}` : `dealers`
  const instance = await ApiClient(true)
  const { data } = await instance.get(query)
  return data
}

const create = async (dealerData: Dealer) => {
  const instance = await ApiClient(true)
  const { data } = await instance.post(`dealers`, dealerData)
  return data
}

const updateDealer = async (username: string, dealerData: EditDealer) => {
  const instance = await ApiClient(true)
  const { data } = await instance.put(`dealers/${username}`, dealerData)
  return data
}

const deleteDealer = async (username: string) => {
  const instance = await ApiClient(true)
  const { data } = await instance.delete(`dealers/${username}`)
  return data
}

const getDealer = async (username: string) => {
  const instance = await ApiClient(true)
  const { data } = await instance.get(`dealers/${username}`)
  return data
}

const getDealerByToken = async (token: string) => {
  const instance = await ApiClient(true)
  const { data } = await instance.get(`b2c/dealer/${token}`)
  return data
}

export default {
  get,
  create,
  updateDealer,
  deleteDealer,
  getDealer,
  getDealerByToken
}
